import {
  CLEAR_ERROR,
  CROSS_DOMAIN_ACCOUNT_SEARCH,
  FETCH_ACCOUNT,
  FETCH_ACCOUNT_ERROR,
  FETCH_ACCOUNT_START,
  FETCH_ACCOUNT_END,
  REMOVE_ACCOUNT,
  INITIALIZE_USER,
  INITIALIZE_USER_ERROR,
} from '../actions/types';

const initialState = {
  isLoading: null,
  accounts: [],
};

export default function(state = initialState, action) {
  switch (action.type) {
    case FETCH_ACCOUNT:
      return { ...state, accounts: action.payload };
    case FETCH_ACCOUNT_ERROR:
      return { error: action.payload };
    case CROSS_DOMAIN_ACCOUNT_SEARCH:
      return { crossDomainData: action.payload };
    case FETCH_ACCOUNT_START:
      return { ...initialState, isLoading: true };
    case FETCH_ACCOUNT_END:
      return { ...state, isLoading: false };
    case REMOVE_ACCOUNT:
      return { ...initialState };
    case CLEAR_ERROR:
      return { ...initialState, accounts: state.accounts };
    case INITIALIZE_USER:
      return { ...state, isLoading: true };
    case INITIALIZE_USER_ERROR:
      return { ...state, error: action.payload, isLoading: false };
    default:
      return state;
  }
}
